import React from 'react';
import PropTypes from 'prop-types';

import withModal from '../../../../components/global/modal/withModal';
import RosterIdentityPurchaseHistory from './RosterIdentityPurchaseHistory';

const propTypes = {
  actionProps: PropTypes.shape({
    rosterIdentityId: PropTypes.string.isRequired,
  }),
};

const RosterIdentityPurchaseHistoryModal = ({
  actionProps: { rosterIdentityId },
  ...props
}) => {
  return (
    <RosterIdentityPurchaseHistory
      rosterIdentityId={rosterIdentityId}
      {...props}
    />
  );
};

RosterIdentityPurchaseHistoryModal.propTypes = propTypes;

export const ROSTER_IDENTITY_PURCHASE_HISTORY_MODAL =
  'modal/ROSTER_IDENTITY_PURCHASE_HISTORY';

export default withModal(RosterIdentityPurchaseHistoryModal, {
  name: ROSTER_IDENTITY_PURCHASE_HISTORY_MODAL,
  contentLabel: 'Purchase History',
  size: 'md',
});
